import { inject, Injectable } from "@angular/core";

import { MessageService } from "primeng/api";

import { MessageType } from "@shared/enums";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlingService {
  messageService = inject(MessageService);

  sendMessage(messageType: MessageType): void {
    switch (messageType) {
      case MessageType.ServerError:
        this.messageService.clear();
        this.messageService.add({
          summary: "Server Error",
          detail: "Try again later or send feedback.",
          severity: "error",
          key: "reply",
        });
        break;
      case MessageType.AwaitingResponse:
        this.messageService.clear();
        this.messageService.add({
          summary: "Still Working",
          detail: "Awaiting response from server.",
          severity: "info",
          key: "noReply",
        });
        break;
      case MessageType.NotFound:
        this.messageService.clear();
        this.messageService.add({
          summary: "Missing Data",
          detail: "The requested data could not be found.",
          key: "noReply",
          severity: "warn",
        });
        break;
      default:
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "An error occured. Please try again later.",
        });
        break;
    }
  }
}
